<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    dense
  >
  <template v-slot:activator="{ on, attrs }">
    <v-text-field
      v-model="dateRangeText"
      placeholder="Select Dates Range"
      readonly
      v-bind="attrs"
      v-on="on"
      dense
      solo
      flat
      filled
      :rules="[rules.visitDate]"
      class="component explorer-table-searchable-text mr-0"
      background-color="#f2f2f2"
    >
      <v-icon
        slot="append"
        class="icon-large explorer-table-searchable-icon"
      >
        mdi-calendar
      </v-icon>
    </v-text-field>
  </template>
  <v-date-picker 
    v-model="dates" 
    range
    no-title
    first-day-of-week="1"
  >
    <v-spacer></v-spacer>
    <v-btn 
      text 
      color="primary" 
      @click="closePicker"
      small
    >
      Cancel
    </v-btn>
    <v-btn 
      text 
      color="primary" 
      @click="filterDates"
      small
    >
      OK
    </v-btn>
  </v-date-picker>
</v-menu>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'

export default {
  name: 'ExplorerHeaderDatesRangeFilter',
  data() {
    return {
      dates: [ ],
      menu: false,
      range_valid: true,
      rules: {
        visitDate: v => this.dates.length != 2 || this.dates[0] <= this.dates[1] || "Finish Date can't be earlier than Start Date"
      }
    }
  },
  computed: {
    dateRangeText () {
      if (this.dates) return this.dates.join(' ~ ')
      return ''
    },
    ...mapState([
    'sitePath',
    'current_business_process',
    'searchText',
    'processID',    
  ]),
  },  
  methods:{
    filterDates: function(evt) {
      console.log('filterDates', this.dates)
      // if (evt) evt.preventDefault();
      if (this.dates || this.dates.length){
        if(this.dates[1] >= this.dates[0]){
          this.menu = false
          this.$refs.menu.save(this.dates)
          this.$emit("input", this.dates)
        }
      this.menu = false
      }
    },
    closePicker: function(evt){
      console.log('closePicker', this.dates)
      this.$refs.menu.save([])
      // if (evt) evt.preventDefault();
      if (this.dates.length == 2){
        this.dates = []
        this.menu = false
        this.$refs.menu.save([])
        this.$emit("input", [])
      }
      this.dates = []
      this.menu = false
    },
    ...mapActions(['EXPLORE_UNITS']),
  },
}
</script>


<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
